<template>
  <div class="search-client-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Client Search</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <form>
              <div class="form-group">
                <div class="row">
                  <div class="col">
                    <label>Name</label>
                    <input type="text" class="textbox client-name" v-model="searchOption.ClientName" />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Branch Name</label>
                    <input type="text" class="textbox client-name" v-model="searchOption.BranchName" />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Contact FullName</label>
                    <input type="text" class="textbox client-name" v-model="searchOption.ContactName" />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input type="text" class="textbox hidden-element" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" dark @click="handleModal($event)">Cancel</v-btn>
                    <v-btn dark @click="search">Search</v-btn>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'

export default {
  name: "AdminSearchClientModal",
  data() {
    return {
      loadModal: false,

      searchOption: this.initSearchOption(),
    }
  },
  methods: {
    handleModal(e) {
      this.loadModal = !this.loadModal
      if(this.loadModal) {
        $("html").addClass("modal-mask-open")
        setTimeout(() => {
          $('.search-client-modal form').on('keypress', (e) => {
            if (e.keyCode == 13) {
              this.search()
            }
          })
          $('.search-client-modal .client-name').focus()
        }, 500)
      } else {
        $("html").removeClass("modal-mask-open")
      }
    },
    initSearchOption() {
      return {
        ClientName: "",
        BranchName: "",
        ContactName: "",
      }
    },

    async search() {
      if(this.searchOption.ClientName === "" && this.searchOption.BranchName === "" && this.searchOption.ContactName === "") {
        return false
      }

      this.$store.dispatch("loading/setLoadComponent", true)
      if(this.$route.fullPath.includes("/admin-clients")) {
        await this.$parent.$parent.$parent.searchClient(this.searchOption)

      } else {
        await utilities.delay(1000)
        this.$router.push({ name: 'admin-clients', params: { searchOptionClientProps: this.searchOption } }).catch((err) => {})
      }
      this.handleModal()
      this.$store.dispatch("loading/setLoadComponent", false)
    },
  },
  beforeMount() {},
  mounted() {},
}
</script>
